














import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { OrderAPI } from '@/api/backend-client'
import { Order } from '@/api/model/order'

@Component
export default class LeadCrumb extends Vue {
    @Prop() readonly route!: Route
    @Prop() readonly last!: boolean

    order: Order = null

    async mounted() {
        this.order = await OrderAPI.get(this.$route.params.orderId)
    }

    get componentClasses(): object {
        return {
            'crumb': true,
            'crumb--last': this.last,
        }
    }
}

